import {cookies, pages, privacyPolicySections} from '../../../../../modules/constants-enumerate';
import '../../../../../modules/link-to-element';
import '../../../../../modules/picture';
import {imageConfig} from '../../__config/images';
import Cookies from 'js-cookie';

const isRegionCalifornia = Cookies.get(cookies.REGION) === 'CA';

export default (ctx, html) => html`
  <form id="${ctx.formFieldId}" action="" @submit="${(e) => ctx.submitForm(e)}" novalidate>
    <div id="email-wrapper">
      ${Cookies.get(cookies.ELOG) ?
        html`
          <a dom-scope="C37n4CQQ" class="learn-more-link top" href="${pages.SUBSCRIPTION}" tab-outline-blue>
            <div id="learn-more-container">
              <aofl-picture>
                ${imageConfig.learnMoreButton.map((image) => html`
                  <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
                `)}
                  <aofl-img id="learn-more-top" src="${imageConfig.learnMoreButton[8].src}" width="424" height="172" alt="subscription page learn more link"></aofl-img>
              </aofl-picture>
            </div>
         </a>
          <a dom-scope="rjs0LQ+i" class="learn-more-link bottom" type="button" href="${pages.SUBSCRIPTION}" tab-outline-blue>
            <aofl-picture>
              ${imageConfig.learnMoreButton.map((image) => html`
                <aofl-source media="(max-width: ${image.maxWidth}px)" srcset="${image.src}"></aofl-source>
              `)}
                <aofl-img id="learn-more-bottom" src="${imageConfig.learnMoreButton[8].src}" width="424" height="172" alt="subscription page learn more link"></aofl-img>
            </aofl-picture>
         </a>
        ` :
        html`

        <input id="${ctx.emailId}" class="${ctx.form.email.valid ? '' : 'invalid'} email-field montserrat tab-outline-blue" name="email" autocomplete="on" type="email" placeholder=${ctx.placeholderText} @input="${(e) => ctx.updateEmail(e)}" @blur="${(e) => ctx.validateEmail(e)}" aria-label="Enter your email address." aria-describedby="reg-form-error-message" required>
          <button dom-scope="c1Tsc7Ts" id="submit" class="button neuton tab-outline-blue" type="submit" aria-label="Submit your email address to begin your adventure" @click="${(e) => ctx.submitForm(e)}">SUBMIT</button>
      </div>
      `}
    </div>
    ${Cookies.get(cookies.ELOG) ? '' : html`
      <div id="checkbox-wrapper">
        ${ctx.form.email.isRequired.valid ? '' : html`
          <label id="reg-form-error-message" class="error-message montserrat" for="${ctx.emailId}" role="alert" aria-label="Error - Please enter an email address. It is a required field and must be filled in">Please enter an email address.</label>
        `}
        ${ctx.form.email.isValidEmail.valid ? '' : html`
          <label id="reg-form-error-message" class="error-message montserrat" for="${ctx.emailId}" role="alert" aria-label="Error - Please enter a valid email address. It is a required field and must be filled in">Please enter a valid email address.</label>
        `}
        ${ctx.form.email.isNotEmoji.valid ? '' : html`
          <label id="reg-form-error-message" class="error-message montserrat" for="${ctx.emailId}" role="alert" aria-label="Error - Please enter a valid email address. It is a required field and must be filled in">Please enter a valid email address.</label>
        `}
        ${ctx.form.checkbox.isChecked.valid ? '' : html`
          <label id="reg-form-error-message" class="error-message montserrat checkbox-error" for="${ctx.emailId}" role="alert"  aria-label="Error - You must agree to receive emails from Adventure Academy. It is required and must be checked">You must agree to receive emails from Adventure Academy.</label>
        `}
        ${ctx.form.apiErrors.uncaught.valid ? '' : html`
          <label id="reg-form-error-message" class="error-message montserrat" role="alert"  aria-label="Server error, please try again later">Sorry, an unknown error occurred.</label>
        `}
        <input type="checkbox" name="accept-emails" id="${ctx.regFormId}" class="checkbox" @change="${(e) => ctx.updateCheckbox(e)}" .checked="${ctx.checkbox}" aria-label="Check to confirm you agree to receive emails from Adventure Academy. I agree to receive emails from Adventure Academy" aria-describedby="reg-form-error-message" aria-labelledby="${ctx.regFormId}-label" required tabindex="-1">
        <label id="${ctx.regFormId}-label" for="${ctx.regFormId}" class="montserrat"><p id="agree-text">I agree to receive emails from Adventure Academy.</p>
        <span id="checkbox-focus" class="tab-outline-blue enteractive-checkbox" for="${ctx.regFormId}" @click="${(e) => ctx.updateCheckbox(e)}" role="checkbox" tabindex="0" aria-label="Check to confirm you agree to receive emails from Adventure Academy. I agree to receive emails from Adventure Academy" aria-describedby="reg-form-error-message"></span>
      </label>
        ${isRegionCalifornia ? html`
          <link-to dom-scope="IYCK4dRa" id="prospect-pp-link" class="link montserrat" href="${privacyPolicySections.CALIFORNIA_PRIVACY_RIGHTS}" target="_blank" rel="noopener noreferrer" tab-outline-blue>Privacy Policy</link-to>
        `: html`
          <link-to dom-scope="gHH9bucA" id="prospect-pp-link" class="link montserrat" href="${pages.PRIVACY_POLICY}" target="_blank" rel="noopener noreferrer" tab-outline-blue>Privacy Policy</link-to>
        `}
      </div>
    `}
  </form>
  <template id="top-prospect-reg"></template>
  <template id="top-prospect-reg-checkbox"></template>
  <template id="top-prospect-reg-email"></template>
  <template id="top-prospect-reg-id"></template>
  <template id="bottom-prospect-reg"></template>
  <template id="bottom-prospect-reg-checkbox"></template>
  <template id="bottom-prospect-reg-email"></template>
  <template id="bottom-prospect-reg-id"></template>
  <template class="modal-reg"></template>
`;
